import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ApiKeyPermissionMapping = React.lazy(() =>
    import('../ApiKeyPermissionMapping')
);
const apiKeyPermissionMappingRoutesRegistry = [
    {
        path: PAGE_URL.API_KEY_PERMISSION_MAPPING_PAGE,
        element: <ApiKeyPermissionMapping />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default apiKeyPermissionMappingRoutesRegistry;
